"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _cuid = _interopRequireDefault(require("cuid"));

var SmileyNormalFill = function SmileyNormalFill(props) {
  var uniqueId = (0, _cuid["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, props, {
    uniqueId: uniqueId,
    iconName: "SmileyNormalFill"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10 0C4.48567 0 0 4.48567 0 10C0 15.5143 4.48567 20 10 20C15.5143 20 20 15.5143 20 10C20 4.48567 15.5143 0 10 0ZM13.0557 5.41667C13.8997 5.41667 14.5833 6.101 14.5833 6.94433C14.5833 7.78833 13.8997 8.472 13.0557 8.472C12.2117 8.472 11.528 7.78833 11.528 6.94433C11.5277 6.101 12.2113 5.41667 13.0557 5.41667ZM6.94433 5.41667C7.78833 5.41667 8.472 6.101 8.472 6.94433C8.472 7.78833 7.78833 8.472 6.94433 8.472C6.10033 8.472 5.41667 7.78833 5.41667 6.94433C5.41667 6.101 6.10033 5.41667 6.94433 5.41667ZM14.5833 13.8193H5.41667C4.99433 13.8193 4.65267 13.477 4.65267 13.0553C4.65267 12.6337 4.994 12.2913 5.41667 12.2913H14.5833C15.0057 12.2913 15.3473 12.6337 15.3473 13.0553C15.3473 13.4773 15.0057 13.8193 14.5833 13.8193Z",
    fill: "url(#".concat(uniqueId, ")")
  }));
};

var _default = SmileyNormalFill;
exports["default"] = _default;